export default __webpack_public_path__ + "static/media/Ballroll_00375.691e46b0.png";